import styles from './Logo.module.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import logo from '../../assets/logo.svg';

const Logo = ({ className, ...props }) => {
  return (
    <img
      className={classNames(styles.logo, className)}
      {...props}
      alt={`Gyrofighters`}
      src={logo}
    />
  );
};

Logo.propTypes = {
  className: PropTypes.string,
};

Logo.defaultProps = {
  className: null,
};

export default Logo;
